import {
  FeedbackMessages,
  useFeedback,
} from '@/components/notifications/Feedback/useFeedback';
import {
  DeleteMenuItemWithConfirmationModal,
  DeleteMenuItemWithConfirmationModalProps,
} from '@/components/poppers/MenuPopper/DeleteMenuItemWithConfirmationModal';
import { useReportError } from '@/hooks/useReportError';
import { useDeleteDsuePortabilityMutation } from '@/modules/estateTaxScenarios/modals/DSUEModal/graphql/DSUEForm.generated';

interface DeleteDSUEMenuItemProps
  extends Partial<DeleteMenuItemWithConfirmationModalProps> {
  dsueId: string;
  onDelete?: () => void;
  modalProps?: Record<string, unknown>;
  menuItemProps?: Record<string, unknown>;
}

export function DeleteDSUEMenuItem({
  dsueId,
  onDelete,
  modalProps = {},
  menuItemProps = {},
  ...deleteProps
}: DeleteDSUEMenuItemProps) {
  const { showFeedback } = useFeedback();
  const { reportError } = useReportError();

  const [deleteDsue, { loading: deleting }] = useDeleteDsuePortabilityMutation({
    variables: { id: dsueId },
    refetchQueries: 'active',
    awaitRefetchQueries: true,
    onError: (error) => {
      showFeedback(FeedbackMessages.deleteError);
      reportError('Failed to delete DSUE', error);
    },
    onCompleted: () => {
      showFeedback(FeedbackMessages.formSaveSuccess, { variant: 'success' });
      onDelete?.();
    },
  });

  return (
    <DeleteMenuItemWithConfirmationModal
      label="Delete DSUE"
      onConfirmDelete={() => deleteDsue()}
      {...deleteProps}
      menuItemProps={{ loading: deleting, ...menuItemProps }}
      modalProps={{
        heading: 'Are you sure you want to delete this DSUE?',
        ...modalProps,
      }}
    />
  );
}
